import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Operations from '../../../operations'
import { sizes } from '@lmc/common/constants'
import { Spinner } from '../../../components/generic'
import SuccessMessage from './components/SuccessMessage'
import { Card, CrashIcon, EmptyState, NoDataIcon, PageHeader } from '@lmc/ui-kit'
import { EmptyStateDescription } from '@lmc/ui-kit/src/dataDisplay/EmptyState'
import { getNominative } from '@lmc/common/utils'
import StockSection from './components/StockSection'

export function StockAlertsReportScreen(props) {
  const {
    fetchStockReport,
    isLoading,
    stockReport,
    preferredPeopleNominative,
    error,
  } = props

  React.useEffect(() => {
    fetchStockReport()
  }, [])

  if (isLoading || (!stockReport && !error)) return <Spinner />

  if (error) {
    return (
      <div style={styles.container}>
        <PageHeader title="Stock Levels" />
        <div style={styles.bodyContainer}>
          <Card>
            <EmptyState
              title="Oops.. Something went wrong"
              icon={<CrashIcon />}
            />
          </Card>
        </div>
      </div>
    )
  }

  const active = stockReport?.active || []
  const inactive = stockReport?.inactive || []

  const hasAnyAlerts =
    active.some((r) => (r.outOfStock?.length > 0 || r.lowStock?.length > 0) && r.name) ||
    inactive.some((r) => (r.outOfStock?.length > 0 || r.lowStock?.length > 0) && r.name)

  const stocksLink =
    'https://support.logmycare.co.uk/en/articles/5249509-how-does-expected-stock-work'

  return (
    <div style={styles.container}>
      <PageHeader title="Stock Levels" />
      <div style={styles.bodyContainer}>
        {!hasAnyAlerts ? (
          active.length === 0 && inactive.length === 0 ? (
            <Card>
              <EmptyState
                title="No stock information has been added yet"
                description={
                  <EmptyStateDescription>
                    Try adding Stock under the{' '}
                    {getNominative(preferredPeopleNominative, 'resident')}'s
                    Medications.
                    <br />
                    Learn more about how to add stocks{' '}
                    <a
                      style={{ textDecoration: 'underline' }}
                      href={stocksLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      here
                    </a>
                    .
                  </EmptyStateDescription>
                }
                icon={<NoDataIcon />}
              />
            </Card>
          ) : (
            <SuccessMessage />
          )
        ) : (
          <>
            <StockSection
              title="Active Residents"
              entries={active}
            />
            <StockSection
              title="Non-Active Residents"
              entries={inactive}
            />
          </>
        )}
      </div>
    </div>
  )
}

StockAlertsReportScreen.propTypes = {
  fetchStockReport: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  stockReport: PropTypes.object,
  preferredPeopleNominative: PropTypes.string,
  error: PropTypes.any,
}

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    padding: '24px 24px',
    position: 'relative',
  },
  bodyContainer: { paddingTop: 24 },
}

const mapStateToProps = (state) => ({
  stockReport: state.data.requests?.['stock-report']?.response,
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
  isLoading: state.data.requests?.['stock-report']?.isLoading,
  error: state.data.requests?.['stock-report']?.error,
})

const mapDispatchToProps = (dispatch) => ({
  fetchStockReport: () =>
    dispatch(
      Operations.fetchData({
        url: '/emar/medication-schedule-patterns/reports/low-stock',
        id: 'stock-report',
      }),
    ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StockAlertsReportScreen)
